export default __webpack_public_path__ + "static/media/antp_ReformasPenales_ponentesregistroWEB.34ad50af.jpg";